import { CustomerOrderDto, TradeDto } from 'common/api/autogenerated/trading-gateway';

export const initialState: {
  init: boolean;
  loading: boolean;
  orders?: CustomerOrderDto[] | null;
  trades?: TradeDto[] | null;
  latestTrade?: TradeDto | null;
  orderIdIsEditing: string | number | null;
} = {
  init: true,
  loading: false,
  orders: [],
  orderIdIsEditing: null,
  latestTrade: null,
};
